// src/hooks/useInView.js
import { useEffect, useRef, useState } from "react";

export default function useInView({ threshold = 0.15, root = null, rootMargin = "0px", once = true } = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let frozen = false;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setInView(true);
            if (once && !frozen) {
              io.unobserve(el);
              frozen = true;
            }
          } else if (!once) {
            setInView(false);
          }
        });
      },
      { threshold, root, rootMargin }
    );

    io.observe(el);
    return () => io.disconnect();
  }, [threshold, root, rootMargin, once]);

  return { ref, inView };
}
